import React from 'react';
import { useTranslate } from '@hooks';
import { ModalWithInitialButton as Modal } from '@dotone/react-ui-core';
import Form from './MarketplaceInviteForm';

const MarketplaceInviteFormModal = ({
  defaultValues = {},
  onToggle,
  buttonProps: givenButtonProps,
  ...otherProps
}) => {
  const { t } = useTranslate('marketplace', 'actions');

  const buttonProps = {
    color: 'primary',
    children: t('invite'),
    variant: 'send',
    ...givenButtonProps,
  };

  return (
    <Modal
      dense
      size="xlg"
      scrollable={false}
      footer={false}
      onToggle={onToggle}
      title={t('marketplace:inviteModal.title')}
      form={<Form defaultValues={defaultValues} />}
      buttonProps={buttonProps}
      {...otherProps}
    />
  );
};

export default MarketplaceInviteFormModal;
